<template>
  <div id="footer" class="footer-bottom">Copyright © {{ year }} Delta IT. All Rights Reserved.</div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      year: new Date().getFullYear(),
    }
  },
}
</script>

<style scoped>
.footer-bottom {
  /*background-color: #e0e0e0;*/
  font-size: 12px;
  color: #212121;
  text-align: center;
  line-height: 50px;
  background-color: #fafafa;
  padding-right: 1rem;
  position: fixed;
  height: 50px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow: hidden;
  z-index: 100;
}
@media (max-width: 1025px) {
  .footer-bottom {
    left: 0px;
  }
}
@media (min-width: 1026px) {
  .menuOpen .footer-bottom {
    left: 299px;
  }
}
</style>
